import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as BoxContained} from "assets/img/box-contained.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {OMSRoutes} from "utils/OMSRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function ProductsItem(props) {
    const {currentPath, selectedRetailer, currentMemberAuthorizations, isUserAdmin} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.PICKING_RETAILER) || !selectedRetailer || isUserAdmin) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<BoxContained />}
            to={OMSRoutes.RETAILER_ORDERS(selectedRetailer.id)}
            selected={currentPath.startsWith(OMSRoutes.RETAILERS)}
        >
            <FormattedMessage id='sidebar.item.products' />
        </SidebarItem>
    );
}

export default ProductsItem;
